import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toCurrency } from '../../utils/helper';

export default function LogCard({
  action,
  type,
  subtype,
  amount,
  date,
  reference,
  transaction,
  otherData,
}) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const gameComissionsDetails = () => {
    if (type === 'COMMISSION' && transaction) {
      const commission = (amount.price / transaction.totalAmount) * 100;
      console.log(amount.price);
      return `${commission.toFixed(2)}% of ${transaction.totalAmount}`;
    }
  };
  return (
    <div className=' bg-white  '>
      <div className='flex items-start gap-2.5 border p-2.5 mt-2.5 rounded-md'>
        <div className='flex-1'>
          <div className='flex justify-between'>
            <div className='text-left'>
              <span className={`text-xs leading-4 text-[#65758B]`}>
                {action}
              </span>
              <h3 className='font-bold text-sm'>{type}</h3>
              {action === 'MANUAL LOAD TO USER' &&
                otherData.userIdLoaded !== '' && (
                  <span className={`text-xs leading-4 text-[#65758B]`}>
                    User{' '}
                    <a
                      href={`/user-games/${otherData.userIdLoaded}`}
                      className='text-[#007BFF]'
                    >
                      {otherData.userNameLoaded
                        ? otherData.userNameLoaded
                        : `# ${otherData.userIdLoaded}`}
                    </a>
                  </span>
                )}
              {transaction && transaction.User !== '' && (
                <span className='text-xs leading-4 text-[#65758B]'>
                  From:{' '}
                  {user.name === transaction.User.name
                    ? 'Self'
                    : transaction.User.name}
                </span>
              )}
            </div>

            <div className='text-right'>
              <p className='text-[10px] text-[#65758B]'>
                {new Date(date)
                  .toLocaleDateString('en-US', {
                    month: 'short',
                    day: '2-digit',
                    year: 'numeric',
                  })
                  .replace(',', '')}{' '}
                {new Date(date)
                  .toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  })
                  .replace(' ', '')}
              </p>
              <p className='text-[10px] text-[#65758B]'>
                {gameComissionsDetails()}
              </p>
              <p className={`font-bold text-base text-${amount.color}`}>
                {action === 'DEDUCTED'
                  ? `-${toCurrency(amount.price)}`
                  : toCurrency(amount.price)}
              </p>
              {otherData && (
                <p className={`text-[10px] text-[#65758B]`}>
                  {toCurrency(otherData?.balance)}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
